import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor() {}

  goToLoginScreen(): void {
    window.location.pathname = '/login';
  }

  goToHome(): void {
    window.location.pathname = '/';
  }

  reloadScreen(): void {
    location.reload();
  }

  back(): void {
    window.history.back();
  }
}
